import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCqrPr2Hr1TETqr4y6e18inyOdxvZh46Vc",
  authDomain: "skyline-backpackers-e5b75.firebaseapp.com",
  projectId: "skyline-backpackers-e5b75",
  storageBucket: "skyline-backpackers-e5b75.firebasestorage.app",
  messagingSenderId: "830588408964",
  appId: "1:830588408964:web:19533f897ef53e4abd5ed1",
  measurementId: "G-3TDR4MLNPW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const analytics = getAnalytics(app);
const db = getFirestore(app);

// Debug: Log successful initialization
console.log('Firebase initialized successfully');

// Export services
export { auth, googleProvider, analytics, db };

export default app;
